import styles from "./LanguageSwitcher.module.css";

const LANGUAGE_LABELS: Record<string, string> = {
  "en-GB": "EN",
  fr: "FR",
  de: "DE",
  es: "ES",
  "zh-CN": "ZH",
  "ja-JP": "JA",
};

type Props = {
  outputLanguage: string;
  activeLanguage: string;
  onSwitch: (language: string) => void;
};

export function LanguageSwitcher({ outputLanguage, activeLanguage, onSwitch }: Props) {
  if (outputLanguage === "en-GB") return null;

  const inputLabel = LANGUAGE_LABELS["en-GB"] ?? "EN";
  const outputLabel = LANGUAGE_LABELS[outputLanguage] ?? outputLanguage.toUpperCase();

  return (
    <div className={styles.switcher}>
      <button
        type="button"
        className={styles.option}
        data-active={activeLanguage === "en-GB"}
        onClick={() => onSwitch("en-GB")}
      >
        {inputLabel}
      </button>
      <button
        type="button"
        className={styles.option}
        data-active={activeLanguage === outputLanguage}
        onClick={() => onSwitch(outputLanguage)}
      >
        {outputLabel}
      </button>
    </div>
  );
}
